import { useState } from "react";

import LogoSection from "../../components/logoSection/LogoSection";
import { DeliveryCount } from "../../models/deliveryCount";
import { TagName } from "../../models/tag";
import "./Dashboard.scss";
import WelcomeSection from "./sections/welcomeSection/WelcomeSection";
import YourDeliveriesSection from "./sections/yourDeliveriesSection/YourDeliveriesSection";

const initialCounts: DeliveryCount[] = [
  { key: TagName.Today, value: 0 },
  { key: TagName.Tomorrow, value: 0 },
  { key: TagName.Future, value: 0 },
  { key: TagName.NotPlanned, value: 0 },
  { key: TagName.AllDeliveries, value: 0 },
];

interface DashboardScreenProps {}

const Dashboard = (props: DashboardScreenProps) => {
  const [counts, setCounts] = useState(initialCounts);

  const setDeliveryCount = (count: DeliveryCount) => {
    setCounts((prevCounts) =>
      prevCounts.map((prevCount) =>
        prevCount.key === count.key ? count : prevCount,
      ),
    );
  };

  return (
    <div className="home-screen-container">
      <div className="welcome-container">
        <div className="welcome-section welcome-container-divider">
          <WelcomeSection />
        </div>
        <div className="your-deliveries-section welcome-container-divider">
          <YourDeliveriesSection
            deliveryCount={counts}
            setDeliveryCount={setDeliveryCount}
          />
        </div>
      </div>
      <div className="home-screen-footer">
        <div className="home-screen-footer-corner-left" />
        <div className="bonussystem-section">
          <LogoSection variant="arvato" />
        </div>
        <div className="home-screen-footer-corner-right" />
      </div>
    </div>
  );
};

export default Dashboard;
